import {createStyles, makeStyles} from "@material-ui/core/styles";

const SpaceNoneStyles = makeStyles(() =>
  createStyles({
    grid: {
      minHeight: "70vh",
    },
  }),
);

export default SpaceNoneStyles;
